import { z } from 'zod';
import { isValidEmail } from '../../../utils/Regex';

export const loginSchema = z.object({
  email: z.string().trim().min(1, 'Email is Required').refine(isValidEmail, 'Invalid email address'),
  password: z.string().min(1, 'Password is Required').min(8, 'Password is invalid'),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
